import {Component, OnInit} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroupCreate} from '../../shared/models/routeGroup.model';

@Component({
    selector: 'form-route-group',
    templateUrl: 'form-route-group.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormRouteGroupComponent implements OnInit {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService) {
    }

    routeGroupForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.routeGroupForm = new FormGroup({
            'title': new FormControl(null, Validators.required),
            'calendar_group': new FormControl(null, Validators.required),
            'dispatch_group_id': new FormControl(null, Validators.required)
        });
    }

    onAddRouteGroup() {
        const newRouteGroup = new RouteGroupCreate(
            this.routeGroupForm.value.title, this.routeGroupForm.value.acct
            , this.routeGroupForm.value.calendar_group, this.routeGroupForm.value.dispatch_group_id);
        this.dataStorageService.createRouteGroup(newRouteGroup);
    }
}
